import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { FormikForm } from "components/FormikForm/FormikForm";
import { TextArea } from "components/DesignSystem/TextArea/TextArea";
import * as Yup from "yup";

type RequestChangesFormValues = {
  reason: string;
};

type RequestChangesConfirmationModalProps = {
  show: boolean;
  onClose: () => void;
  period: string;
  onConfirm: (reason: string) => void;
  isLoading?: boolean;
};

const requestChangesValidationSchema = Yup.object().shape({
  reason: Yup.string().required("Please describe what needs to change"),
});

export const RequestChangesConfirmationModal = ({
  show,
  onClose,
  period,
  onConfirm,
  isLoading = false,
}: RequestChangesConfirmationModalProps) => {
  const onSubmit = (values: RequestChangesFormValues) =>
    onConfirm(values.reason);

  return (
    <Modal.Root open={show} onOpenChange={onClose} modal>
      <Modal.Content onClick={(e) => e.stopPropagation()}>
        <FormikForm
          initialValues={{ reason: "" }}
          validationSchema={requestChangesValidationSchema}
          onSubmit={onSubmit}
          noValidate
        >
          <>
            <Modal.Header>
              <Modal.Title>Request changes</Modal.Title>
              <Modal.Close />
            </Modal.Header>
            <Modal.Body>
              <p className="t-m-0 t-text-body-sm t-text-text-60 t-mb-4">
                You're about to request changes to the financials for{" "}
                <span className="t-font-bold">{period}</span>. Your bookkeeper
                will review your request and either update the closing or get
                back to you with a clarification.
              </p>
              <TextArea
                name="reason"
                label="What needs to change?"
                placeholder="Briefly describe what's incorrect"
                required
                rows={5}
                autoResize
              />
            </Modal.Body>
            <Modal.FooterButtonGroup>
              <Modal.RawClose asChild>
                <Button type="button" disabled={isLoading}>
                  Cancel
                </Button>
              </Modal.RawClose>
              <Button
                type="submit"
                customType="danger"
                isLoading={isLoading}
                disabled={isLoading}
              >
                Send request
              </Button>
            </Modal.FooterButtonGroup>
          </>
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
